import styled from 'styled-components';
import { responsiveProperty } from '../../utils/responsiveProperty/responsiveProperty.js';
import { marginProps, marginPropsNames } from '../../utils/responsiveProperty/margin.js';
import { paddingProps, paddingPropsNames } from '../../utils/responsiveProperty/padding.js';

var invalidProps = [].concat(marginPropsNames, paddingPropsNames, ['display', 'width', 'flexDirection', 'alignItems', 'justifyContent', 'gap']);
var shouldForwardProp = function shouldForwardProp(prop) {
  return !invalidProps.includes(prop);
};
var StyledBox = styled.div.withConfig({
  shouldForwardProp: shouldForwardProp
}).withConfig({
  displayName: "StyledBox",
  componentId: "sc-11zlxk3-0"
})(["", ";", ";", ";", ";", ";", ";", " ", ""], function (props) {
  return props.display ? responsiveProperty('display', props.display) : 'display: flex';
}, function (props) {
  return props.width && responsiveProperty('width', props.width);
}, function (props) {
  return props.flexDirection && responsiveProperty('flexDirection', props.flexDirection);
}, function (props) {
  return props.alignItems && responsiveProperty('alignItems', props.alignItems);
}, function (props) {
  return props.justifyContent && responsiveProperty('justifyContent', props.justifyContent);
}, function (props) {
  return props.gap && responsiveProperty('gap', props.gap);
}, marginProps, paddingProps);

export { StyledBox };
